// Keep in sync with backend/campaign_rules.py; six is a limit, not a default.
export const MAX_CAMPAIGN_DRIVERS = 6;
export const CAMPAIGN_DRIVER_OPTIONS = Array.from({ length: MAX_CAMPAIGN_DRIVERS }, (_, i) => i + 1);